
import React, { useEffect, useState, useRef } from 'react';
import { createChart } from 'lightweight-charts';
import { Box, Autocomplete, TextField, Button } from "@mui/material";



const Brokerranking = () => {
  const [crosshairDataPoint, setCrosshairDataPoint] = useState(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [selectedBroker, setSelectedBroker] = useState(null);
  const [symbols, setSymbols] = useState([]);
  const chartContainerRef1 = useRef(null);
const chartContainerRef2 = useRef(null);

const fetchDataForCharts = () => {
  // Fetch data for first chart
  fetch('http://127.0.0.1:5000/api/data/close/mar/12')
    .then(response => response.json())
    .then(data => {
      // Remove the previous chart element
      const chartContainer1 = chartContainerRef1.current;
      while (chartContainer1.firstChild) {
        chartContainer1.removeChild(chartContainer1.firstChild);
      }

      const chart1 = createChart(chartContainerRef1.current, {
        width: chartContainerRef1.current.clientWidth,
        height: chartContainerRef1.current.clientHeight,
        crosshair: {
          mode: 0
        }
      });
      chartContainerRef1.current.chartInstance = chart1;

      const lineSeries1 = chart1.addLineSeries({ color: 'red' });
      lineSeries1.setData(data);

      // Fetch data for second chart after initializing the first one
      if (!selectedBroker) return;

      fetch(`http://127.0.0.1:5000/db/${selectedBroker}`)
        .then(response => response.json())
        .then(data => {
          // Remove the previous chart element
          const chartContainer2 = chartContainerRef2.current;
          while (chartContainer2.firstChild) {
            chartContainer2.removeChild(chartContainer2.firstChild);
          }

          const chart2 = createChart(chartContainerRef2.current, {
            width: chartContainerRef2.current.clientWidth,
            height: chartContainerRef2.current.clientHeight,
            crosshair: {
              mode: 0
            }
          });
          chartContainerRef2.current.chartInstance = chart2;

          const lineSeries2 = chart2.addLineSeries({ color: 'green' });
          lineSeries2.setData(data);

          // Subscribe to crosshair events after initializing both charts
          subscribeCrosshairMove(chart1, chart2, lineSeries1, lineSeries2);
          subscribeCrosshairMove(chart2, chart1, lineSeries2, lineSeries1);
          subscribeVisibleLogicalRangeChange(chart1, chart2);
          subscribeVisibleLogicalRangeChange(chart2, chart1);
        })
        .catch(error => console.error('Error fetching data for second chart:', error));
    })
    .catch(error => console.error('Error fetching data for first chart:', error));
};


  useEffect(() => {
    fetch('http://127.0.0.1:5000/api/brokers')
      .then(response => response.json())
      .then(data => setSymbols(data.map(broker => broker.label)))
      .catch(error => console.error('Error fetching symbols:', error));
  }, []);

  const handleCrosshairMove = (param, sourceSeries, targetChart, targetSeries) => {
    const dataPoint = getCrosshairDataPoint(sourceSeries, param);
    syncCrosshair(targetChart, targetSeries, dataPoint);
    setCrosshairDataPoint(dataPoint);
  };

  const syncCrosshair = (chart, series, dataPoint) => {
    if (dataPoint) {
      chart.setCrosshairPosition(dataPoint.value, dataPoint.time, series);
    } else {
      // chart.clearCrosshairPosition();
    }
  };

  const getCrosshairDataPoint = (series, param) => {
    if (!param.time || !param.seriesData) {
      return null;
    }
    return param.seriesData.get(series) || null;
  };

  const subscribeCrosshairMove = (sourceChart, targetChart, sourceSeries, targetSeries) => {
    sourceChart.subscribeCrosshairMove((param) => {
      handleCrosshairMove(param, sourceSeries, targetChart, targetSeries);
    });
  };

  const subscribeVisibleLogicalRangeChange = (sourceChart, targetChart) => {
    sourceChart.timeScale().subscribeVisibleLogicalRangeChange(timeRange => {
      targetChart.timeScale().setVisibleLogicalRange(timeRange);
    });
  };


  return (
    <Box sx={{
      position: 'absolute',
      margin: 0,
      padding: 0,
      top: 0,
      right: '0vw',
      //backgroundColor: 'yellow',
      width: '77%',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      //zIndex: '-100'

    }}>
  
      {/* Second chart with input and button */}
      <div style={{ width: '50%', float: 'right' }} >
        <Box sx={{
          position: 'absolute',
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          //bgcolor: 'yellow',
          left: 0,
          top: '2vh',
          zIndex: '100000'
        }}>
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={symbols}
            value={selectedBroker}
            onChange={(event, newValue) => {
              setSelectedBroker(newValue);
            }}
            sx={{ width: 300 }}
            renderInput={(params) => <TextField {...params} label="Symbols" />}
          />
          <Button variant="contained" onClick={fetchDataForCharts}>
            Search
          </Button>
        </Box>
        <Box sx={{
          position: 'absolute',
          width: '100vw',
          height: '90vh',
          //backgroundColor: 'greenyellow',
          bottom: '0vh',
          left: '-14vw',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
         //justifyContent: 'center',
        }}>
          <div ref={chartContainerRef1} style={{ width: '77%', height: '45%',}} >
            Set
          </div>
          <br />
          <div ref={chartContainerRef2} style={{ width: '77%', height: '45%' }} >
            Broker value
          </div>
        </Box>
      </div>
    </Box>
  );
};

export default Brokerranking;

